import Api from "api/Api";
import type { AuditLogsFiltersReduxState } from "ee/reducers/auditLogsReducer";
import { payloadToQueryParams } from "ee/pages/AuditLogs/utils/payloadToQueryParams";

export class AuditLogsApi extends Api {
  static fetchAuditLogsLogsURL = "/v1/audit-logs/logs";
  static fetchAuditLogsMetadataURL = "/v1/audit-logs/filter";

  static async fetchAuditLogsLogsNextPageFromDB(
    payload: AuditLogsFiltersReduxState & { cursor: number },
  ) {
    return Api.get(
      AuditLogsApi.fetchAuditLogsLogsURL,
      payloadToQueryParams(payload),
    );
  }

  static async fetchAuditLogsLogsFromDB(payload: AuditLogsFiltersReduxState) {
    return Api.get(
      AuditLogsApi.fetchAuditLogsLogsURL,
      payloadToQueryParams(payload),
    );
  }
  static async fetchAuditLogsMetadataFromDB() {
    return Api.get(AuditLogsApi.fetchAuditLogsMetadataURL);
  }
  static async fetchAuditLogsForDownload(payload: AuditLogsFiltersReduxState) {
    return Api.get(
      AuditLogsApi.fetchAuditLogsLogsURL,
      payloadToQueryParams(payload),
    );
  }
}

export default AuditLogsApi;
